/* eslint-disable no-unused-vars */

// COOKIE HELPERS
function setCookie(cname, cvalue, exdays) {
	var d = new Date();
	var cookie = cname + "=" + cvalue + ";";
	if (exdays !== 0) {
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		var expires = "expires=" + d.toGMTString();
		cookie = cookie + " " + expires;
	}
	document.cookie = cookie;
}

function getCookie(cname) {
	var name = cname + "=";
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		//	var c = ca[i].trim(); //This does not work in IE8
		var c = $.trim(ca[i]); //use jQuery instead
		if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
	}
	return "";
}

function deleteCookie(cname) {
	document.cookie = cname + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT";
}

$(document).ready(function () {

    agp.knockout.init();
	agp.browser.init();
	agp.boxes.init();
	agp.boxes.setColors();
	agp.Util.initGlobalLoader();
	//agp.datepicker.init();
	//agp.tablesorter.init();
	//agp.fileupload.init();
	agp.scroll.init();
	agp.sitefooter.init();
	agp.disclaimer.init();
    agp.track.bind();
	


	$(document).on("click", ".js--toggleTerms", function (evt) {
		evt.preventDefault();
		$(this).toggleClass("open");
		$(this).next("div").slideToggle();
	});
	numeral.language('da-dk');
	moment.locale("da-DK");
});